var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5614 19.0007C15.4034 19.0007 15.2444 18.9637 15.0984 18.8877L9.99938 16.2237L4.90138 18.8877C4.56338 19.0627 4.15538 19.0327 3.84938 18.8087C3.54138 18.5847 3.38838 18.2057 3.45338 17.8307L4.42438 12.2027L0.304379 8.21765C0.0303789 7.95265 -0.0686211 7.55465 0.0483789 7.19065C0.165379 6.82865 0.478379 6.56365 0.856379 6.50965L6.55638 5.68165L9.10438 0.555654C9.44238 -0.124346 10.5574 -0.124346 10.8954 0.555654L13.4434 5.68165L19.1434 6.50965C19.5214 6.56365 19.8344 6.82865 19.9514 7.19065C20.0684 7.55465 19.9694 7.95265 19.6954 8.21765L15.5754 12.2027L16.5464 17.8307C16.6114 18.2057 16.4574 18.5847 16.1504 18.8087C15.9764 18.9367 15.7694 19.0007 15.5614 19.0007Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/StarFilled.e43d09dd9a9012391fef3e10f03f9c6f.svg";
export { ForwardRef as ReactComponent };